import React from 'react'
export default function Nav({ menuClass, children }) {
    return (
        <nav className="nav-wrapper">
            <ul className={`nav-list ${menuClass ? menuClass : ''}`}>{children}</ul>
        </nav>
    )
}
